import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <circle cx={9} cy={7.5} r={2.75} />
    <path d="M14.233 2.184C12.788.728 10.894 0 9 0S5.212.728 3.767 2.184c-2.89 2.912-2.89 7.633 0 10.544L9 18l5.233-5.272c2.89-2.912 2.89-7.633 0-10.544zM9 11.75c-2.343 0-4.25-1.906-4.25-4.25S6.657 3.25 9 3.25s4.25 1.906 4.25 4.25-1.907 4.25-4.25 4.25z" />
  </svg>
);

export default SvgComponent;
